import { AlertDialogContent } from '@/components/ui/alert-dialog'
import { Loader2 } from 'lucide-react'

export default function IsLoading() {
  return (
    <AlertDialogContent className="max-w-2xl max-h-[80vh]">
    <div className="flex justify-center items-center h-40">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  </AlertDialogContent>
  )
}